import React, { useRef, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FormikFormTopico } from "../Topico";
import GAS from "../../../GAS";

const HEARTBEAT_INTERVAL_MS = 15000; // renova a cada 15s (TTL backend = 45s)

const ModalEditarTopico = ({ visible, setDialogEditarTopico, setEditTopico, setPainel, metamodeloAvaliativo, filtroEixos, filtroDimensoes, painel, usuario, editTopico, showMessage, idSessao }) => {
    const dialogTitle = editTopico?.editIndex === false ? 'Adicionar tópico' : 'Editar tópico';
    const gasObj = GAS.getInstance();
    // Captura o nome original antes de qualquer mutação pelo FormikFormTopico
    const originalNome = useRef(editTopico?.topico).current;
    const isEdicao = editTopico?.editIndex !== false && editTopico?.editIndex !== undefined;

    // Heartbeat de renovação do lock 
    useEffect(() => {
        if (!isEdicao) return; // Criação de novo tópico não tem lock a renovar

        const nomeTopico = originalNome || editTopico?.topico;

        const heartbeat = setInterval(async () => {
            try {
                const res = await gasObj.request(
                    'MCPAPainelApropriador.instance.SERVICE.GETLockTopico',
                    painel.proprietario,
                    nomeTopico,
                    usuario.email,
                    idSessao
                );
                if (!res.response?.sucesso) {
                    showMessage('warn', 'Edição interrompida',
                        `Sua sessão expirou e ${res.response?.bloqueadoPor || 'outro usuário'} assumiu a edição deste tópico. Você não conseguirá salvar.`);
                }
            } catch (error) {
                console.error('Erro ao renovar lock do tópico:', error);
            }
        }, HEARTBEAT_INTERVAL_MS);

        return () => clearInterval(heartbeat);
    }, [isEdicao]);

    const fecharELiberarLock = async () => {
        const nomeTopico = originalNome || editTopico?.topico;
        setDialogEditarTopico(false);
        setEditTopico(null);
        try {
            if (isEdicao) {
                await gasObj.request(
                    'MCPAPainelApropriador.instance.SERVICE.DELETELockTopico',
                    painel.proprietario, nomeTopico, usuario.email, idSessao
                );
            }
        } catch (error) {
            console.error("Erro ao liberar lock do tópico:", error);
        }
    };

    const handleSalvarTopico = async (topico) => {
        topico.revisao = { data: new Date().toJSON(), usuario: usuario.email };

        if (editTopico.editIndex === false || editTopico.editIndex === undefined) {
            topico.eixoNumero = filtroEixos.numero;
            topico.dimensaoNumero = filtroDimensoes.numero;
            topico.acoes = [];
            topico.criacao = topico.revisao;
        }

        const { editIndex: _editIndex, ...topicoParaSalvar } = topico;

        setDialogEditarTopico(false);
        
        if (!isEdicao) {
            painel.topicos.push(topicoParaSalvar);
        } else {
            painel.topicos[editTopico.editIndex] = topicoParaSalvar;
        }
        setPainel({ ...painel });
        setEditTopico(null);

        try {
            const resposta = await gasObj.request(
                'MCPAPainelApropriador.instance.SERVICE.POSTSalvarTopico',
                painel.proprietario,
                topicoParaSalvar,
                isEdicao ? originalNome : undefined,
                idSessao
            );

            if (resposta.response?.sucesso === false && resposta.response?.motivo === 'LOCK_PERDIDO') {
                showMessage('error', 'Conflito de edição',
                    `Este tópico foi editado por ${resposta.response.bloqueadoPor} enquanto você o tinha aberto. Recarregando a página...`);
                setTimeout(() => window.location.reload(), 2500); // dá tempo do toast aparecer antes do reload
                return;
            }

            showMessage('success', 'Salvo', 'Tópico salvo com sucesso.');
        } catch (e) {
            console.error("erro ao salvar... :", e);
            showMessage('error', 'Erro', 'Falha ao sincronizar o tópico com o servidor.');
        }
    };

    const footer = (
        <div className="p-d-flex p-jc-between p-mt-3">
            <Button className="p-button-danger" label="CANCELAR" icon="pi pi-times" onClick={fecharELiberarLock} />
            <Button type="submit" form="edit-topico" label={editTopico?.editIndex === false ? "ADICIONAR" : "SALVAR"} icon="pi pi-check" />
        </div>
    );

    const DROPDOWN_OPTIONS_ORIGEM = [
        { label: 'REIVINDICAÇÃO COMUNIDADE INTERNA', value: 'REIVINDICAÇÃO COMUNIDADE INTERNA' },
        { label: 'REIVINDICAÇÃO COMUNIDADE EXTERNA', value: 'REIVINDICAÇÃO COMUNIDADE EXTERNA' },
        { label: 'RESULTADO AVALIAÇÃO INTERNA', value: 'AVALIAÇÃO INTERNA' },
        { label: 'RESULTADO AVALIAÇÃO EXTERNA', value: 'AVALIAÇÃO EXTERNA' }
    ];

    const DROPDOWN_OPTIONS_SENTIMENTO = [
        { label: 'POTENCIALIDADE', value: 'POTENCIALIDADE' },
        { label: 'FRAGILIDADE', value: 'FRAGILIDADE' }
    ];

    const DROPDOWN_OPTIONS_NIVELORGANIZACIONAL = Object.entries(metamodeloAvaliativo.tiposNiveisOrganizacionais).map(tipoNivelOrganizacionalEntry => {
        return {
            label: tipoNivelOrganizacionalEntry[1], value: tipoNivelOrganizacionalEntry[1]
        }
    }).sort((a, b) => a.label.localeCompare(b.label));

    const DROPDOWN_OPTIONS_SEGMENTOS = Object.entries(metamodeloAvaliativo.tiposSegmentos).map(tipoSegmentoEntry => {
        return {
            label: tipoSegmentoEntry[1], value: tipoSegmentoEntry[1]
        }
    }).sort((a, b) => a.label.localeCompare(b.label));

    return (
        <Dialog 
            closable={false} 
            header={dialogTitle} 
            footer={footer} 
            visible={visible} 
            style={{ width: '85vw' }} 
            modal 
            onHide={fecharELiberarLock} 
        >
            <FormikFormTopico
                id="edit-topico"
                dropdownOptions={{
                    origem: DROPDOWN_OPTIONS_ORIGEM, 
                    sentimento: DROPDOWN_OPTIONS_SENTIMENTO, 
                    nivelOrganizacional: DROPDOWN_OPTIONS_NIVELORGANIZACIONAL, 
                    segmentos: DROPDOWN_OPTIONS_SEGMENTOS
                }}
                handleSubmit={handleSalvarTopico}
                topico={editTopico}
            />
        </Dialog>
    );
};

export default ModalEditarTopico;